import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-20" }
const _hoisted_2 = {
  class: "-mx-5 -my-2 flex flex-wrap justify-center",
  "aria-label": "Footer"
}
const _hoisted_3 = {
  key: 0,
  class: "mt-8 flex justify-center space-x-6"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "sr-only" }

import { DefineComponent, ref } from 'vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '../../services/integration/enums';

type MainLink = {
  name: string,
  href: string
}

type SocialLink = {
  name: string,
  href: string,
  icon: DefineComponent
}


export default /*#__PURE__*/_defineComponent({
  props: {
    main: { type: Array, required: true },
    social: { type: Array, required: false }
  },
  setup(__props: any) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');



const brandTitle = brandService.getTitle();
const year = ref(new Date().getFullYear());


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'bg-brand-secondary' : 'bg-white', ""])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.main, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.name,
            class: "px-5 py-2"
          }, [
            _createVNode(_component_router_link, {
              to: item.href,
              class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'text-white' : 'text-gray-500' , "text-base hover:text-gray-900"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"])
          ]))
        }), 128))
      ]),
      (__props.social && __props.social.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.social, (item) => {
              return (_openBlock(), _createElementBlock("a", {
                key: item.name,
                href: item.href,
                class: "text-gray-400 hover:text-gray-500"
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(item.name), 1),
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                  class: "h-6 w-6",
                  "aria-hidden": "true"
                }))
              ], 8, _hoisted_4))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", {
        class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'text-white' : 'text-gray-400' , "mt-8 text-center text-base"])
      }, " © " + _toDisplayString(year.value) + " • " + _toDisplayString(_unref(brandTitle)) + " • All rights reserved. ", 3)
    ])
  ], 2))
}
}

})